// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WorkaroundIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 64 64">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.94 46.45a2.67 2.67 0 0 1 0-5.33h7.82a6.5 6.5 0 0 0 6.52-6.32V19.82l.01-.33a8.73 8.73 0 0 1 17.43.33V34.8a6.5 6.5 0 0 0 6.52 6.33h5l-3.08-3.09a2.08 2.08 0 0 1 2.94-2.94l7.22 7.22c.8.82.8 2.13 0 2.94l-7.22 7.22a2.08 2.08 0 1 1-2.94-2.93l3.09-3.09h-5.01A11.84 11.84 0 0 1 35.38 34.6v-.98q0 2.2 0 0V19.7a3.39 3.39 0 0 0-6.76 0v15.26a11.84 11.84 0 0 1-11.86 11.5z"
      clipRule="evenodd"
    />
  </svg>,
  "Workaround",
);
export default WorkaroundIcon;
